/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * This type of object is known as an improvement when described on a UI. However it is known as a `Recommendation` here because that is how it is refered to in RdSAP.
 */
export interface RdSAPAssessmentReportRecommendation { 
    /**
     * The number of a recommendation
     */
    readonly item: number;
    /**
     * The text that should be displayed to a user of the data. This relates to what is displayed on the EPC certificate.
     */
    readonly recommendationText: string;
    /**
     * The pound saving value of the recomendation.
     */
    costSaving: number;
    /**
     * The EPC rating which will be achieved on completion of the recomendation.
     */
    energyEfficiency: number;
    /**
     * The environmental impact that would be achieved on completion of the recomendation.
     */
    enviromentalImpact: number;
    /**
     * Installation price
     */
    installationPrice: string;
}

